import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import React, { Fragment } from 'react';
import { change } from 'redux-form';
import { faMinusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/substitution-form.module.scss';
import { FieldDropdown } from 'src/components/redux-form/fields/FieldDropdown';
import { FieldDate } from '../../../../../components/redux-form/fields/FieldDate';
import { Validators } from '../../../../../components/redux-form/utils/validators';
import { OrderFormData } from './OrderMultiForm';
import OrderEnum from 'src/enumerables/order-enum';
import { getValFromEnum } from '../../../../../components/redux-form/utils/dropdown-values';
import { changeToZeroMomentDate } from '../../../../../helpers/timeHelpers';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        formData,
        isNew,
        isDraft,
        OrderTypes,
        ServiceTypeProviders,
        serviceTypesOrderValues,
        validators,
        statusItemValue,
        statusInit,
    } = props;

    return (
        <ul className={classNames(styles.ul)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    order={formData?.orders && formData.orders[index]}
                    form={formData}
                    OrderTypes={OrderTypes}
                    ServiceTypeProviders={ServiceTypeProviders}
                    serviceTypesOrderValues={serviceTypesOrderValues}
                    statusInit={statusInit}
                    statusItemValue={statusItemValue}
                    validators={validators}
                    isDraft={isDraft}
                    isNew={isNew}
                    member={member}
                    fields={array}
                    index={index}
                />
            ))}
            <div className={'d-flex  w-100 mt-3'}>
                <button
                    type="button"
                    className={classNames('btn', 'btn-info')}
                    onClick={() => fields.push({ status: 1 })}
                >
                    Add Service Type Form
                </button>
            </div>
        </ul>
    );
};
type Props = {
    member: any;
    isNew: boolean;
    form: any;
    order: any;
    isDraft: boolean;
    statusInit: any;
    validators: Validators<OrderFormData>;
    statusItemValue: string | number;
    OrderTypes: SelectObject[];
    ServiceTypeProviders: SelectObject[];
    serviceTypesOrderValues: SelectObject[];
    index: number;
    fields: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    index,
    fields,
    validators,

    statusInit,
    statusItemValue,
    form,
    order,

    OrderTypes,
    ServiceTypeProviders,
    isNew,
    isDraft,
    serviceTypesOrderValues,
}) => {
    const AllocatedPeriod = OrderEnum ? OrderEnum.getEnum('AllocatedPeriod') : {};
    const valuesAllocatedPeriod: SelectObject[] = getValFromEnum(AllocatedPeriod);
    const fieldsRender: any = {
        1: (
            <Fragment>
                <FieldDropdown
                    name={`${member}.allocatedPeriodDropDown`}
                    data={valuesAllocatedPeriod}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.allocatedPeriodDropDown : undefined}
                    wrapperConfig={{
                        label: 'Allocated Hours per *:',
                    }}
                />
                <FieldInput
                    name={`${member}.allocatedHours`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours *:',
                    }}
                />
                <FieldInput
                    name={`${member}.maximumAvailableHours`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.maximumAvailableHours : undefined}
                    wrapperConfig={{
                        label: 'Maximum Available Hours *:',
                    }}
                />
            </Fragment>
        ),
        2: (
            <Fragment>
                <FieldInput
                    name={`${member}.allocatedHours`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours *:',
                    }}
                />
            </Fragment>
        ),
        3: (
            <Fragment>
                <FieldInput
                    name={`${member}.allocatedMoney`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedMoney : undefined}
                    wrapperConfig={{
                        label: 'Amount of money allocated, $ *:',
                    }}
                />
            </Fragment>
        ),
        4: <Fragment></Fragment>,
        6: (
            <Fragment>
                <FieldDropdown
                    name={`${member}.allocatedPeriodDropDown`}
                    data={valuesAllocatedPeriod}
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.allocatedPeriodDropDown : undefined}
                    wrapperConfig={{
                        label: 'Allocated Hours per *:',
                    }}
                />
                <FieldInput
                    name={`${member}.allocatedHours`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.allocatedHours : undefined}
                    wrapperConfig={{
                        label: 'Number of allocated hours *:',
                    }}
                />
                <FieldInput
                    name={`${member}.maximumAvailableHours`}
                    type="number"
                    disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                    validate={!isDraft ? validators.maximumAvailableHours : undefined}
                    wrapperConfig={{
                        label: 'Maximum Available Hours *:',
                    }}
                />
            </Fragment>
        ),
    };

    const orderType = order && order?.orderTypeDropDown?.value ? order.orderTypeDropDown.value : 1;

    const serviceTypeProvider = order && order?.serviceTypeProviderDropDown?.value ? order.serviceTypeProviderDropDown.value : 1;

    const dispatch = useDispatch();
    const row = fields.get(index);
    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
        } else {
            dispatch(change('payment-form', `${member}.status`, 2));
        }
    };

    const backRow = () => {
        dispatch(change('payment-form', `${member}.status`, 1));
    };
    const creditStyle = {
        background: 'grey',
    };

    const isApplied: boolean = +row.status === 3;

    let name: any = [];
    const student_caseNumber: any = [];
    const caseDate: any = [];
    if (form.studentDropDown) {
        student_caseNumber.push(form.studentDropDown.label);
    }
    if (form.caseNumber) {
        student_caseNumber.push(form.caseNumber);
    }
    if (student_caseNumber.length) {
        name.push(student_caseNumber.join('_'));
    }

    if (order.serviceTypeProviderDropDown?.value) {
        name.push(order.serviceTypeProviderDropDown.label);
    }

    if (order.serviceTypeDropDown?.value) {
        name.push(order.serviceTypeDropDown.label);
    }



    if (order.caseNumberValidityFrom) {
        caseDate.push(
            changeToZeroMomentDate(
                order.caseNumberValidityFrom ? order.caseNumberValidityFrom.split('T')[0] : undefined,
            ),
        );
    }

    if (order.caseNumberValidityTo) {
        caseDate.push(
            changeToZeroMomentDate(order.caseNumberValidityTo ? order.caseNumberValidityTo.split('T')[0] : undefined),
        );
    }
    if (caseDate.length) {
        name.push(caseDate.join('_'));
    }

    if (order.location) {
        name.push(order.location);
    }

    name = name.join('/');

    return (
        <li style={+row.status === 2 ? creditStyle : {}} key={index}>
            <div className={classNames(styles.wrapForm)}>
                <div className={' mr-5'}>

                    <FieldDropdown
                        name={`${member}.serviceTypeProviderDropDown`}
                        data={ServiceTypeProviders}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.serviceTypeProviderDropDown : undefined}
                        wrapperConfig={{
                            label: 'Service Type Provider *:',
                        }}
                    />
                    <FieldDropdown
                        name={`${member}.serviceTypeDropDown`}
                        data={serviceTypesOrderValues}
                        disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.serviceTypeDropDown : undefined}
                        wrapperConfig={{
                            label: 'Service Type *:',
                        }}
                    />
                    <FieldDropdown
                        name={`${member}.orderTypeDropDown`}
                        data={OrderTypes}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.orderTypeDropDown : undefined}
                        wrapperConfig={{
                            label: 'Order Type:',
                        }}
                    />

                    <div> {fieldsRender[orderType]}</div>
                </div>

                <div className={''}>
                    <FieldInput
                        name={`${member}.name`}
                        type="text"
                        input={{
                            value: name,
                        }}
                        disabled={true}
                        wrapperConfig={{
                            label: 'Order name (Student_case number/service type provider/service type/date range/service location):',
                        }}
                    />

                    <label>Location for order name only *:</label>
                    <div className={classNames(styles.wrapList)}>
                        {['Home', 'School'].map((it: string, k: number) => (
                            <div key={k} className={classNames(styles.item)}>
                                <div className={classNames(styles.left)}>
                                    <FieldInput
                                        name={`${member}.location`}
                                        value={`${it}`}
                                        type="radio"
                                        wrapperConfig={{
                                            classes: {
                                                inputWrapper: 'customCheckbox',
                                            },
                                        }}
                                    />
                                </div>
                                <div className={classNames(styles.paddingTopItem)}>{it}</div>
                            </div>
                        ))}
                    </div>
                    <span className={'mb-2 d-block'}>Case Number Validity From *:</span>
                    <div className={` d-flex flex-row align-items-start miniW mr-5 ${styles.wrapDate}`}>
                        <div className={classNames(styles.minWidthDate)}>
                            <FieldDate
                                name={`${member}.caseNumberValidityFrom`}
                                type="text"
                                wrapperConfig={{
                                    classes: {
                                        inputContainer: `Date-wrap mr-3 `,
                                    },
                                    label: '',
                                }}
                                date={true}
                                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                validate={!isDraft ? validators.caseNumberValidityFrom : undefined}
                            />
                        </div>

                        <div className={classNames(styles.minWidthDate, styles.marginminus)}>
                            <FieldDate
                                name={`${member}.caseNumberValidityTo`}
                                type="text"
                                date={true}
                                wrapperConfig={{
                                    label: 'To *:',
                                    classes: {
                                        label: styles.labelStyle,
                                    },
                                }}
                                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                validate={!isDraft ? validators.caseNumberValidityTo : undefined}
                            />
                        </div>
                    </div>


                    <label>Order Expiration *:</label>
                    <div className={classNames(styles.wrapList)}>
                        <div className={classNames(styles.minWidthDate)}>
                            <FieldDate
                                name={`${member}.orderExpiration`}
                                type="text"
                                wrapperConfig={{
                                    classes: {
                                        inputContainer: `Date-wrap mr-3 `,
                                    },
                                    label: '',
                                }}
                                date={true}
                                disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                                validate={undefined}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className={classNames(styles.wrapButton)}>
                {' '}
                {!isApplied ? (
                    +row.status !== 2 ? (
                        <button type="button" className={'btn'} title="Remove Member" onClick={() => deleteRow()}>
                            <FontAwesomeIcon size={'2x'} icon={faMinusCircle}/>
                        </button>
                    ) : (
                        <button type="button" className={'btn'} title="Remove Member" onClick={() => backRow()}>
                            <FontAwesomeIcon size={'2x'} icon={faRedo}/>
                        </button>
                    )
                ) : (
                    'Applied'
                )}
            </div>
        </li>
    );
};
export default RenderFieldArray;
